/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Unnamedthread1Inputs */

const zh_common_unnamedthread1 = /** @type {(inputs: Common_Unnamedthread1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未命名对话`)
};

const en_common_unnamedthread1 = /** @type {(inputs: Common_Unnamedthread1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled Conversation`)
};

const es_common_unnamedthread1 = /** @type {(inputs: Common_Unnamedthread1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversación sin título`)
};

/**
* | output |
* | --- |
* | "Untitled Conversation" |
*
* @param {Common_Unnamedthread1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const common_unnamedthread1 = /** @type {((inputs?: Common_Unnamedthread1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Unnamedthread1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_common_unnamedthread1(inputs)
	if (locale === "en") return en_common_unnamedthread1(inputs)
	return es_common_unnamedthread1(inputs)
});
export { common_unnamedthread1 as "common_unnamedThread" }